import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SavedCard } from "@models/credit-card";

@Component({
  selector: "app-credit-card-wallet",
  imports: [],
  templateUrl: "./credit-card-wallet.component.html",
  styleUrl: "./credit-card-wallet.component.scss",
})
export class CreditCardWalletComponent {
  @Input() savedCards: SavedCard[] = [];
  @Input() selectedCard?: SavedCard;
  @Input() showSelection = true;
  @Input() showDelete = false;
  @Input() title = "Cartões Salvos";

  @Output() selectedCardChange = new EventEmitter<SavedCard | undefined>();
  @Output() deleteCard = new EventEmitter<SavedCard>();

  getCardBrandIcon(brand: string): string {
    const brandIcons: { [key: string]: string } = {
      Visa: "💳",
      Mastercard: "💳",
      "American Express": "💳",
      Elo: "💳",
      Hipercard: "💳",
    };
    return brandIcons[brand] || "💳";
  }

  formatCardNumber(card: SavedCard): string {
    const maskedDigits = "**** **** ****";
    return `${maskedDigits} ${card.last_four_digits}`;
  }

  formatExpiryDate(card: SavedCard): string {
    const month = card.exp_month.toString().padStart(2, "0");
    const year = card.exp_year.toString().slice(-2);
    return `${month}/${year}`;
  }

  handleSelectCardClick(card: SavedCard) {
    if (!this.showSelection) return;
    this.selectedCard = card;
    this.selectedCardChange.emit(card);
  }

  handleDeleteClick(card: SavedCard, event: Event) {
    event.stopPropagation();
    this.deleteCard.emit(card);
  }
}
